import { Navigate } from 'react-router-dom'
export default function OrganizationsPage() {
  return <Navigate to="/admin/platform/tenants" replace />
}
